import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FiShoppingBag, FiTruck, FiHome, FiSmartphone, FiMapPin,
  FiClock, FiDollarSign, FiZap, FiCheckCircle, FiPhone,
  FiMail, FiShield, FiStar, FiUsers, FiArrowRight, FiInstagram
} from 'react-icons/fi';

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-2xl font-bold text-gray-900">BARUERI</span>
            <span className="text-2xl">⚡</span>
            <span className="text-2xl font-bold text-gray-900">FLASH</span>
          </div>
          <button 
            onClick={() => navigate('/login')}
            className="bg-red-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-red-700 transition-colors"
          >
            Entrar
          </button>
        </div>
      </header>

      {/* Hero Section - Para Clientes */}
      <section className="bg-gradient-to-b from-gray-50 to-white py-16 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <span className="inline-block bg-red-100 text-red-600 px-4 py-2 rounded-full text-sm font-medium mb-6">
            Para Você, Morador de Barueri
          </span>
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Descubra lojas perto de você
          </h1>
          
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-12">
            Compre local, receba rápido. Apoie o comércio do seu bairro e tenha seus produtos em mãos sem complicação.
          </p>

          {/* Features Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 text-left">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
                <FiShoppingBag className="w-6 h-6 text-blue-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Lojas Locais</h3>
              <p className="text-gray-600 text-sm">
                Encontre eletrônicos, acessórios e muito mais em comércios de Barueri.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 text-left">
              <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-4">
                <FiTruck className="w-6 h-6 text-green-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Entrega Rápida</h3>
              <p className="text-gray-600 text-sm">
                Receba seu pedido em casa com entregadores da própria cidade.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 text-left">
              <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center mb-4">
                <FiSmartphone className="w-6 h-6 text-purple-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Acompanhe em Tempo Real</h3>
              <p className="text-gray-600 text-sm">
                Veja onde está seu pedido no mapa até chegar na sua porta.
              </p>
            </div>
          </div>

          <button 
            onClick={() => navigate('/vitrine')}
            className="bg-red-600 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-red-700 transition-colors inline-flex items-center gap-2"
          >
            Quero Comprar
            <FiArrowRight className="w-5 h-5" />
          </button>
        </div>
      </section>

      {/* Seção Para Comerciantes */}
      <section className="bg-white py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <span className="inline-block bg-green-100 text-green-600 px-4 py-2 rounded-full text-sm font-medium mb-6">
                Para Comerciantes
              </span>
              
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Você é comerciante?
                <br />
                <span className="text-green-600">Venda online sem complicação</span>
              </h2>
              
              <p className="text-gray-600 mb-8">
                Alcance mais clientes em Barueri sem precisar de site próprio ou aplicativo. Gestão simples, tudo pelo celular.
              </p>

              {/* Steps */}
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-4">
                  <span className="w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center font-semibold text-sm flex-shrink-0">1</span>
                  <div>
                    <h4 className="font-semibold text-gray-900">Cadastre sua loja</h4>
                    <p className="text-gray-600 text-sm">Crie seu perfil em minutos</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <span className="w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center font-semibold text-sm flex-shrink-0">2</span>
                  <div>
                    <h4 className="font-semibold text-gray-900">Publique produtos</h4>
                    <p className="text-gray-600 text-sm">Adicione fotos e preços</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <span className="w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center font-semibold text-sm flex-shrink-0">3</span>
                  <div>
                    <h4 className="font-semibold text-gray-900">Comece a vender</h4>
                    <p className="text-gray-600 text-sm">Receba pedidos no celular</p>
                  </div>
                </div>
              </div>

              <button 
                onClick={() => navigate('/login?role=lojista')}
                className="bg-green-600 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-green-700 transition-colors inline-flex items-center gap-2"
              >
                <FiHome className="w-5 h-5" />
                Cadastrar Minha Loja
                <FiArrowRight className="w-5 h-5" />
              </button>
            </div>

            {/* Benefits Card */}
            <div className="bg-green-50 p-8 rounded-2xl">
              <h3 className="font-semibold text-gray-900 mb-6">O que você ganha:</h3>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                    <FiUsers className="w-5 h-5 text-green-600" />
                  </div>
                  <span className="text-gray-700">Alcance milhares de moradores</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                    <FiSmartphone className="w-5 h-5 text-green-600" />
                  </div>
                  <span className="text-gray-700">Gerencie tudo pelo celular</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                    <FiTruck className="w-5 h-5 text-green-600" />
                  </div>
                  <span className="text-gray-700">Entregadores já disponíveis</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                    <FiShield className="w-5 h-5 text-green-600" />
                  </div>
                  <span className="text-gray-700">Pagamentos seguros via PIX</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                    <FiStar className="w-5 h-5 text-green-600" />
                  </div>
                  <span className="text-gray-700">Receba avaliações dos clientes</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Seção Para Entregadores */}
      <section className="bg-gray-50 py-16 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <span className="inline-block bg-orange-100 text-orange-600 px-4 py-2 rounded-full text-sm font-medium mb-6">
            Para Entregadores
          </span>
          
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Ganhe dinheiro fazendo entregas
          </h2>
          
          <p className="text-gray-600 max-w-2xl mx-auto mb-10">
            Trabalhe quando quiser, aceite corridas pelo celular e ganhe por cada entrega realizada.
          </p>

          {/* Benefits */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <div className="text-3xl font-bold text-orange-600 mb-2">R$ 10</div>
              <p className="text-gray-600">por entrega realizada</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <FiClock className="w-8 h-8 text-orange-600 mx-auto mb-2" />
              <p className="text-gray-600">Horário flexível</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <FiZap className="w-8 h-8 text-orange-600 mx-auto mb-2" />
              <p className="text-gray-600">Pagamento semanal</p>
            </div>
          </div>

          <button 
            onClick={() => navigate('/login?role=entregador')}
            className="bg-orange-600 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-orange-700 transition-colors inline-flex items-center gap-2"
          >
            <FiTruck className="w-5 h-5" />
            Quero Ser Entregador
            <FiArrowRight className="w-5 h-5" />
          </button>
        </div>
      </section>

      {/* Seção Leva e Traz */}
      <section className="bg-white py-16 px-4 border-t border-gray-100">
        <div className="max-w-6xl mx-auto">
          <div className="bg-gradient-to-r from-purple-600 to-indigo-600 rounded-2xl p-8 md:p-12 text-white">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <span className="inline-block bg-white/20 px-4 py-1 rounded-full text-sm font-medium mb-4">
                  Novo Serviço
                </span>
                <h2 className="text-3xl md:text-4xl font-bold mb-4">
                  Leva e Traz & Ponto a Ponto
                </h2>
                <p className="text-purple-100 mb-6">
                  Precisa buscar ou entregar algo? Nossos motoboys fazem isso por você! 
                  Documentos, chaves, pequenas encomendas...
                </p>
                <div className="flex flex-wrap gap-4 mb-6">
                  <div className="bg-white/10 px-4 py-2 rounded-lg">
                    <span className="text-2xl font-bold">R$ 20</span>
                    <span className="text-sm text-purple-200 ml-1">por trecho</span>
                  </div>
                  <div className="bg-white/10 px-4 py-2 rounded-lg">
                    <span className="text-2xl font-bold">R$ 40</span>
                    <span className="text-sm text-purple-200 ml-1">ida e volta</span>
                  </div>
                </div>
                <p className="text-yellow-300 text-sm mb-6 flex items-center gap-2">
                  <span className="w-5 h-5 bg-yellow-300 rounded-full flex items-center justify-center text-yellow-900 text-xs font-bold">!</span>
                  Não transportamos alimentos ou comida
                </p>
                <button 
                  onClick={() => navigate('/express')}
                  className="bg-white text-purple-600 px-8 py-4 rounded-xl font-semibold text-lg hover:bg-purple-50 transition-colors inline-flex items-center gap-2"
                >
                  Conhecer Serviço
                  <FiArrowRight className="w-5 h-5" />
                </button>
              </div>
              <div className="hidden md:flex justify-center">
                <div className="bg-white/10 rounded-2xl p-6 space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-green-400 rounded-full flex items-center justify-center">
                      <FiCheckCircle className="w-5 h-5 text-white" />
                    </div>
                    <span>Documentos e contratos</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-green-400 rounded-full flex items-center justify-center">
                      <FiCheckCircle className="w-5 h-5 text-white" />
                    </div>
                    <span>Chaves e chaveiros</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-green-400 rounded-full flex items-center justify-center">
                      <FiCheckCircle className="w-5 h-5 text-white" />
                    </div>
                    <span>Pequenos eletrônicos</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-green-400 rounded-full flex items-center justify-center">
                      <FiCheckCircle className="w-5 h-5 text-white" />
                    </div>
                    <span>Presentes e encomendas</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="bg-gradient-to-b from-gray-100 to-gray-200 py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Seu bairro mais digital
          </h2>
          <p className="text-gray-600 mb-8">
            Junte-se a quem já está comprando, vendendo e entregando em Barueri.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => navigate('/login?role=cliente')}
              className="bg-red-600 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-red-700 transition-colors inline-flex items-center justify-center gap-2"
            >
              <FiShoppingBag className="w-5 h-5" />
              Explorar Lojas
            </button>
            <button 
              onClick={() => navigate('/login?role=lojista')}
              className="bg-gray-900 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-gray-800 transition-colors inline-flex items-center justify-center gap-2"
            >
              <FiHome className="w-5 h-5" />
              Cadastrar Negócio
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            {/* Brand */}
            <div>
              <div className="flex items-center gap-1 mb-4">
                <span className="text-xl font-bold">BARUERI</span>
                <span className="text-xl text-yellow-400">⚡</span>
                <span className="text-xl font-bold">FLASH</span>
              </div>
              <p className="text-gray-400 text-sm mb-4">
                O marketplace local que conecta moradores, comércios e entregadores de Barueri.
              </p>
              <div className="text-gray-500 text-sm">
                <p className="font-medium text-gray-400">Barueri Flash</p>
                <p>CNPJ: 37.192.230/0001-00</p>
                <p>Barueri – SP</p>
              </div>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-semibold mb-4">Contato</h4>
              <div className="space-y-3">
                <a 
                  href="https://wa.me/5511947726031" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-gray-400 hover:text-green-400 transition-colors"
                >
                  <FiPhone size={18} />
                  <span>(11) 94772-6031</span>
                </a>
                <a 
                  href="mailto:contato@barueriflash.com.br"
                  className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
                >
                  <FiMail size={18} />
                  <span>contato@barueriflash.com.br</span>
                </a>
                <a 
                  href="https://instagram.com/barueriflash" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-gray-400 hover:text-pink-400 transition-colors"
                >
                  <FiInstagram size={18} />
                  <span>@barueriflash</span>
                </a>
              </div>
            </div>

            {/* Links */}
            <div>
              <h4 className="font-semibold mb-4">Links</h4>
              <div className="space-y-2">
                <a href="/termos" className="block text-gray-400 hover:text-white transition-colors text-sm">
                  Termos de Uso
                </a>
                <a href="/privacidade" className="block text-gray-400 hover:text-white transition-colors text-sm">
                  Política de Privacidade
                </a>
                <a href="/sobre" className="block text-gray-400 hover:text-white transition-colors text-sm">
                  Sobre Nós
                </a>
                <a href="/faq" className="block text-gray-400 hover:text-white transition-colors text-sm">
                  Dúvidas Frequentes
                </a>
              </div>
            </div>
          </div>

          {/* Trust badges */}
          <div className="border-t border-gray-800 pt-6 mt-6">
            <div className="flex flex-wrap justify-center gap-6 mb-6 text-gray-500 text-sm">
              <div className="flex items-center gap-2">
                <FiCheckCircle className="text-green-500" />
                <span>Plataforma local verificada</span>
              </div>
              <div className="flex items-center gap-2">
                <FiShield className="text-blue-500" />
                <span>Seus dados estão protegidos</span>
              </div>
              <div className="flex items-center gap-2">
                <FiMapPin className="text-red-500" />
                <span>100% Barueri</span>
              </div>
            </div>
            
            <p className="text-center text-gray-600 text-sm">
              © 2025 Barueri Flash. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
